import type { InventoryListItem } from '@/lib/api/schemas/inventory.schema'
import { Fact, SectionCard, ValueOrReason } from '@/components/warehouse/primitives'
import { businessActivityOf, firstSeenInOnecOf } from '@/lib/warehouse/projection'
import { warehouseDateTime } from '@/lib/warehouse/labels'

export function ProductMovementDetails({ variant, includeReceipt = false }: {
  variant: InventoryListItem
  includeReceipt?: boolean
}) {
  const activity = businessActivityOf(variant)
  const firstSeen = firstSeenInOnecOf(variant)

  return (
    <SectionCard title="Состояние и движение">
      <dl className="grid grid-cols-2 gap-3">
        {includeReceipt ? (
          <Fact label="Поступил">
            {variant.onecArrivedAt
              ? <time dateTime={variant.onecArrivedAt}>{warehouseDateTime(variant.onecArrivedAt)}</time>
              : <ValueOrReason value={null} reason={variant.onecArrivedAtUnavailableReason} />}
          </Fact>
        ) : null}
        <Fact label="Впервые в 1С">
          {firstSeen.at
            ? <time dateTime={firstSeen.at}>{warehouseDateTime(firstSeen.at)}</time>
            : <ValueOrReason value={null} reason={firstSeen.unavailableReason} />}
        </Fact>
        <Fact label="Последнее деловое движение">
          {activity.at
            ? <span data-reason={activity.unavailableReason ?? undefined}><time dateTime={activity.at}>{warehouseDateTime(activity.at)}</time>{activity.source ? <span className="mt-0.5 block text-[10px] text-ink-muted">{activity.source}</span> : null}</span>
            : <ValueOrReason value={null} reason={activity.unavailableReason ?? 'inventory.activity_not_recorded'} />}
        </Fact>
      </dl>
    </SectionCard>
  )
}
